import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// ✅ USE THIS BUCKET – NOT appspot.com
const firebaseConfig = {
  apiKey: "AIzaSyCUBA2B6WPigXHMafmzQornWKhNckNH0JA",
  authDomain: "coiltrading.firebaseapp.com",
  projectId: "coiltrading",
  storageBucket: "coiltrading.firebasestorage.app",
  messagingSenderId: "730266205512",
  appId: "1:730266205512:web:ce491a4fc75e1447b3077d",
  measurementId: "G-0G9XSNVMY9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export services
export const db = getFirestore(app);
export const storage = getStorage(app);